/* import __COLOCATED_TEMPLATE__ from './snippet-mobile.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();